import { createEntityAdapter } from '@reduxjs/toolkit';
import { IValveConnectorEdit } from 'application/editcomp/api/ValveConnectorGrid/ValveConnectorEdit';

export const valveConnectorEditAdapter = createEntityAdapter<IValveConnectorEdit, number>({
  selectId: (project) => project.valveConnectorID,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});
